import Link from 'next/link';
import CardActionArea from '@mui/material/CardActionArea';

export default function CategoryCard({ href, name, description, icon }) {
  return (
    <div
      key={href}
      className="tw-group tw-relative tw-flex tw-rounded-2xl tw-bg-primary-100 dark:tw-bg-primary-900 tw-transition-shadow hover:tw-shadow-md hover:tw-shadow-gray-900/5 hover:tw-bg-primary-200 active:hover:tw-bg-primary-300 dark:hover:tw-bg-primary-800 dark:active:hover:tw-bg-primary-700"
    >
      <CardActionArea>
        <div className="tw-absolute tw-inset-0 tw-rounded-2xl tw-ring-1 tw-ring-inset tw-ring-gray-200 group-hover:tw-ring-gray-900/10" />
        <div className="tw-relative tw-rounded-2xl tw-p-6 tw-pt-16">
          {icon}
          <h3 className="tw-mt-4 tw-font-semibold tw-leading-7 tw-text-gray-900 dark:tw-text-gray-200 tw-m-0">
            <Link href={href}>
              <span className="tw-absolute tw-inset-0 tw-rounded-2xl" />
              {name}
            </Link>
          </h3>
          <p className="tw-mt-1 tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">
            {description}
          </p>
        </div>
      </CardActionArea>
    </div>
  );
}
